export function transformStaticBarData(tooltipData, staticBarValues) {
  const metaData = {};
  const metaTooltip = {};
  const keys = Object.keys(staticBarValues);

  for (const key of keys) {
    const tooltipExists = tooltipData.find(
      (element) => element?.fieldName.replace(/(_\w)/g, (k) => k[1].toUpperCase()) === key
    );

    if (tooltipExists) {
      metaTooltip[key] = {
        tooltips: tooltipExists?.additionalAttributes,
        isLoading: false,
      };
    }

    metaData[key] = {
      fieldName: key,
      ...staticBarValues[key],
    };
  }

  return { metaData, metaTooltip };
}
